import {makeStyles} from "@material-ui/core";

export default function useStyles() {
    return makeStyles((theme) => ({
        loaderSpace: {
            margin: "100px"
        },
        closeButton: {
            zIndex:1,
            position: "absolute",
            marginLeft: "95%",
        },
    }));
};
